const routes = [
  {
    path: '/importTask',
    name: '',
    redirect:'/importTask/list'
  },
  {
    path: '/importTask/list',
    name: '',
    meta:{
      module:'operate_manage',
      menu:'/importTask/list',
      title:'批量修改金标有效期',
      keepAlive: true,
      breadcrumb:['importTask'],
      menuBreadcrumb: 'importTask',
    },//menu 用于所属右侧菜单栏
    component: () => import('@/views/importTask/list.vue'),
  },
]

export default routes;
